var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 50,
    viewBox: "0 0 45 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_38_26)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9845 42.0365V44.5283C21.9845 46.5266 20.9886 48.2517 19.2581 49.2507C18.4255 49.7314 17.4962 49.9995 16.5327 50C15.5683 50.0005 14.6393 49.7318 13.8061 49.2507L2.72646 42.8538C0.995701 41.8546 0 40.13 0 38.1315V5.45292C0 2.44599 2.44609 0 5.45292 0H29.8543C32.8614 0 35.3076 2.4458 35.3076 5.45292V12.3415C35.3076 13.3297 34.5053 14.132 33.5171 14.132C32.5286 14.132 31.727 13.3298 31.727 12.3415V5.45292C31.727 4.4204 30.8869 3.58027 29.8543 3.58027H8.47235L19.2581 9.80848C20.988 10.8075 21.9845 12.5321 21.9845 14.5299V38.4559H29.8543C30.8868 38.4559 31.727 37.6162 31.727 36.5836V30.545C31.727 29.5561 32.5282 28.7544 33.5171 28.7544C34.5057 28.7544 35.3076 29.5563 35.3076 30.545V36.5836C35.3076 39.5907 32.8614 42.0365 29.8543 42.0365H21.9845ZM38.5746 22.8084L36.6029 24.7801C35.9037 25.4792 35.9039 26.6126 36.6029 27.3119C36.769 27.4782 36.9663 27.6102 37.1836 27.7C37.4008 27.7899 37.6337 27.836 37.8688 27.8357C38.104 27.8362 38.3369 27.7901 38.5543 27.7002C38.7716 27.6103 38.969 27.4783 39.1352 27.3119L44.1624 22.2837C44.8613 21.5847 44.8614 20.4519 44.1624 19.7529L39.1352 14.7256C38.436 14.0263 37.3025 14.0266 36.603 14.7255C35.904 15.4239 35.9042 16.5578 36.603 17.2564L38.5746 19.2277H25.3657C24.3765 19.2277 23.5755 20.0293 23.5755 21.0183C23.5755 22.0074 24.3766 22.8085 25.3657 22.8085L38.5746 22.8084Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_38_26"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutDark);
export default __webpack_public_path__ + "static/media/logout-dark.a6985387c63b4aa33d9a2651f2a21f95.svg";
export { ForwardRef as ReactComponent };